import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    authData: {
      authToken: null,
      refreshToken: null,
      tokenTime: "",
      isAuthenticated: false,
    },
    userData: { role: "", email: "", username: "", name: "" , mobileNumber: "", portalUserMobileNumber:""},
    userCurrentLead: {leadId: "",leadStatus:""},
    userAddharTransationDetails: {transationId: ""},
    userAaharDetails: {},
    userSelfieDetailsDigitap: {leadId : ""},
    userSelfieDetails: {},
    userCurrentPaymentDetails: {transactionId: "", amount: "", date: ""},
    userProfileInfo: {},
    adminPortalData: {enabled: false},
    bankAnalyserData: {},
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
    },
    saveUserLeadId: (state, action) => {
      state.userCurrentLead = action.payload
    },
    saveUserAddharTransationDetails: (state, action) => {
      state.userAddharTransationDetails = action.payload
    },
    saveUserAadharDetails: (state, action) => {
      state.userAaharDetails = action.payload
    },
    saveUserSelfieDetailsDigitap: (state, action) => {
      state.userSelfieDetailsDigitap = action.payload
    },
    saveSelfieDetails: (state, action) => {
      state.userSelfieDetails = action.payload
    },
    saveUserCurrentPaymentDetails: (state, action) => {
      state.userCurrentPaymentDetails = action.payload
    },
    saveUserProfileInfo: (state, action) => {
      state.userProfileInfo = action.payload
    },
    saveAdminPortalData: (state, action) => {
      state.adminPortalData = action.payload
    },
    saveBankAnalyserData: (state, action) => {
      state.bankAnalyserData = action.payload
    },
  },
});

export const { saveAuthData, saveUserData, saveUserLeadId, saveUserAddharTransationDetails, saveUserAadharDetails, saveUserSelfieDetailsDigitap, saveSelfieDetails, saveUserCurrentPaymentDetails, saveUserProfileInfo, saveAdminPortalData, saveBankAnalyserData } = loginSlice.actions;

export default loginSlice.reducer;
